import { render, staticRenderFns } from "./HoursOverview.vue?vue&type=template&id=60a16ce0"
import script from "./HoursOverview.vue?vue&type=script&lang=ts"
export * from "./HoursOverview.vue?vue&type=script&lang=ts"
import style0 from "./HoursOverview.vue?vue&type=style&index=0&id=60a16ce0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports